<style scoped="scoped" lang="scss">
.hideFormItem {
  display: none !important;
}

.container {
  padding-left: 24px;
  padding-right: 24px;
  //overflow: auto;
  //min-width: 500px;

  // 隐藏表单项
  .hideFormItem {
    display: none !important;
  }
}
</style>
<template>
  <div class="container">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
    <div>
      <!--筛选设备-->
      <div style="display: flex;flex-direction: row-reverse;">
        <el-button type="primary" size="mini" @click="screenEq" plain>{{ $t("shaixuanshebei") }}</el-button>
      </div>
      <el-tabs v-if="showTab" v-model="activeTitleName" @tab-click="changeTab">
        <!--概览-->
        <el-tab-pane :label="$t('gailan')" name="first">
          <overview :selectEquipment="selectEquipment"></overview>
        </el-tab-pane>
        <!-- 日统计 -->
        <el-tab-pane :label="$t('ritongji')" name="second">
          <daily_statistics :selectEquipment="selectEquipment"></daily_statistics>
        </el-tab-pane>
        <!-- 月统计 -->
        <el-tab-pane :label="$t('yuetongji')" name="third">
          <monthly_statistics :selectEquipment="selectEquipment"></monthly_statistics>
        </el-tab-pane>
        <!-- 班次统计 -->
        <el-tab-pane :label="$t('bancitongji')" name="fourth">
          <shift_statistics :selectEquipment="selectEquipment"></shift_statistics>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" width="720px" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'shezhi'">
        <div class="dialog-scroller">
          <el-transfer style="display: flex;justify-content: center;align-items: center;padding-bottom: 20px;" :titles="[$t('shebeiliebiao'), $t('xuanzhongshebei')]" v-model="selectEquipment" @change="handleChange" :data="equipmentList" :props="{ key: 'id', label: 'name' }"> </el-transfer>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" @click="setBatchEquipmentBoard" type="primary">{{ $t("baocun") }} </el-button>
        </template>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import overview from "@@/pages/web/report/efficiency_report/overview";
import shift_statistics from "@@/pages/web/report/efficiency_report/shift_statistics";
import daily_statistics from "@@/pages/web/report/efficiency_report/daily_statistics";
import monthly_statistics from "@@/pages/web/report/efficiency_report/monthly_statistics";

export default {
  name: "web_report_efficiency_report_index",
  components: {
    overview,
    daily_statistics,
    monthly_statistics,
    shift_statistics,
  },
  data() {
    return {
      activeTitleName: "first",
      equipmentList: [],
      selectEquipment: [],
      saveValue: [],
      showTab: false,
    };
  },
  created() {
    setTimeout(() => {
      this.getEquipmentList();
    }, 0);
  },
  methods: {
    handleChange(value, direction, movedKeys) {
      this.saveValue = value;
    },
    //筛选设备
    async screenEq() {
      await this.yt.showEditDialog("shezhi", {});
      // await this.getEquipmentList()
    },
    // 获取设备列表
    async getEquipmentList() {
      this.showTab = false;
      return await this.http
        .get(
          "/web/equipment/standing_book/page?" +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 1000,
              orderBy: "sort",
            })
        )
        .then((response) => {
          this.equipmentList = response.data.rows || [];
          for (let i = 0; i < this.equipmentList.length; i++) {
            this.$set(this.equipmentList[i], "selected", true);
            if (this.equipmentList[i]["name"] == null) {
              this.equipmentList[i]["name"] = " ";
            }
            this.selectEquipment.push(this.equipmentList[i]["id"]);
          }
          this.showTab = true;
        })
        .catch(() => {
          this.showTab = true;
        });
    },
    //保存
    setBatchEquipmentBoard() {
      // if(this.saveValue){
      //   this.yt.isShowEditDialog = false
      //     this.utils.event_hub.$emit('EFFICENCY_REPORT_OVERVIEW_REFRESHS');
      // }
      //   console.log(this.selectEquipment)
      this.yt.isShowEditDialog = false;
      this.utils.successMessage(this.$t("chenggong"));
    },
    changeTab(tab) {
      if (tab.name == "first") {
        this.utils.event_hub.$emit("EFFICENCY_REPORT_OVERVIEW_REFRESHS");
      }
      if (tab.name == "fourth") {
        this.utils.event_hub.$emit("EFFICENCY_REPORT_RESIZE");
      }
    },
  },
};
</script>
